import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './TooltipComponent.css';

const propTypes = {
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired
};

function TooltipComponent(props) {
  const tooltip = (
    <Tooltip id="TooltipComponent" bsClass="TooltipComponent" className="TooltipComponent">
      {props.content}
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      {props.children}
    </OverlayTrigger>
  );
}

TooltipComponent.propTypes = propTypes;

export default TooltipComponent;



// WEBPACK FOOTER //
// ./src/components/common/tooltipComponent/TooltipComponent.jsx